module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('h2', {
    staticClass: "h2n"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28"
    }
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2t"
  }, [_vm._v("Snacks, Finger Foods, and Party Munchies")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he truth is, once you’re in ketosis, your urge to snack will drop dramatically. You simply won’t be anywhere near as hungry as you once were. Also, there simply are no very low-carb/moderate-protein/high-fat foods that you can eat endlessly and mindlessly—think a giant bucket of popcorn at the movies—without making yourself sick.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, there are times when finger foods are called for! And that’s at parties, of course. There are few better party survival strategies than to take along some stealth health food—wings, stuffed eggs, seasoned nuts—all snacks that will please the crowd while giving you something to eat other than potato chips and pizza.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There’s another great reason for all these recipes: because your hunger will be so much less, there will be times when you’re not interested in a whole meal. These tasty nibbles are so nutritious they’re perfectly good substitutes for a meal now and then. How about on family movie night or game night? Or on a day when everyone is going to be working on some major project together? Just put out a few of these and figure they’re a fine alternative to a sit-down meal.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev56"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29"
    }
  }, [_vm._v("SNACK CRACK")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("You want crunchy, salty, and flavorful? You got it. This amazing recipe makes a lot!")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("12 cups (1.2kg), 48 servings —")]), _vm._v(" Per serving: ("), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup, or 25g): 178 calories; 16g fat (81% calories from fat); 8g protein; 5g carbohydrate; 2g dietary fiber; 3g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (112g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60ml) Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cups (360g) raw, shelled sunflower seeds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cups (348g) raw, shelled pumpkin seeds (aka pepitas)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (145g) almonds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (100g) walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (100g) pecans")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (140g) raw cashew pieces")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 ounces (55g) pork rinds, broken up into almond-size pieces (about 2 cups)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (12g) seasoned salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoons garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 250°F (120°C, or gas mark "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("). While it’s heating, put the butter in a huge roasting pan and slide it in to melt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the butter is melted, stir the Worcestershire into it. Now, add all the seeds and nuts and the pork rinds. Stir until everything is evenly coated with the butter mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a small dish, stir together the seasoned salt, garlic powder, and onion powder. Now, sprinkle this mixture evenly over the nut and seed mixture, a teaspoon at a time, stirring each addition in before adding more. Spread everything evenly in the pan. Toast the mixture in the oven for 2 hours, stirring every 30 minutes or so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Store in a snap-top container. If you’re not having a party, you might want to divide this into a few smaller containers and freeze the extra, so it doesn’t go bad on you. That would be a darned shame.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev57"
    }
  }, [_vm._v("BUTTERED “POPCORN”")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Okay, it’s not exactly like popcorn, but it’s a darned good snack. You can order the sweet corn flavoring from Amazon.com.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("5 servings —")]), _vm._v(" Per serving: 189 calories; 15g fat (73.9% calories from fat); 12g protein; trace carbohydrate; 0g dietary fiber; trace net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (55g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" ounces (100g) pork rinds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon Amaretti sweet corn flavoring")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Salt to taste")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 325°F (170°C, or gas mark 3). Put the butter in a large roasting pan and slide it into the heating oven to melt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, poke a hole in your bag of pork rinds to let the air out and bash it a bit. You’re breaking them up into roughly popcorn-size bits—it’s easier to coat them with the butter that way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the butter is melted, stir the sweet corn flavoring into it. Add the pork rinds to the pan and stir until they’re all evenly coated. Spread them out evenly, put them in the oven, and set the timer for 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the timer beeps, stir and turn the pork rinds. Put them back in the oven for another 5 minutes, and they’re done. Season with salt to taste. Store in an airtight container.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev58"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30"
    }
  }, [_vm._v("EVERYTHING OLD IS NOOCH AGAIN RINDS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("When I was a baby health food freak in the 1970s, nutritional yeast was widely touted as the most super of superfoods, a powerhouse of protein and vitamins. Unfortunately, people insisted on mixing it in juices or smoothies, where it tasted awful. It fell out of favor, partly because yeast-laced orange juice is revolting and partly because people wrongly believed it caused yeast infections. (Nutritional yeast is dead; it won’t grow inside you.)")]), _vm._v(" "), _c('p', {
    staticClass: "introi"
  }, [_vm._v("However, I learned back then that nutritional yeast is great used in savory foods, adding body and umami, not to mention vitamins. And sure enough, there is a revival in popularity of nutritional yeast used in savory foods. It even has a trendy new nickname: nooch. Get some! It has tons of uses. Yes, it has a few carbs, but the vast majority of them are fiber.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("6 servings —")]), _vm._v(" Per serving: 164 calories; 12g fat (66.0% calories from fat); 13g protein; 2g carbohydrate; 1g dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("3"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" ounces (100g) pork rinds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (45ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (8g) nutritional yeast flakes")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon red pepper flakes")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poke a hole in your bag of rinds and bash ’em up a bit into smaller pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put the olive oil in a shallow roasting pan and dump in the rinds. Stir and turn them until they’re evenly coated. Stick ’em in the oven and set the timer for 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, combine the nutritional yeast flakes, red pepper flakes, and salt in either a spice grinder or a mortar and pestle. Grind them together until the nooch is finely powdered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The timer beeped! Pull out your pan. Sprinkle half of the yeast mixture over the rinds, stirring as you do so. Put them back in the oven and bake for another 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the rinds are done, sprinkle and stir in the rest of the yeast mixture. Store in an airtight container.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev59"
    }
  }, [_vm._v("NACHO CHEESE PORK RINDS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("This is for all you Nacho Cheese Doritos fans out there, and I know your name is Legion. These will fill the crunchy-cheese-snack void nicely.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("6 servings —")]), _vm._v(" Per serving: 190 calories; 14g fat (65.5% calories from fat); 14g protein; 3g carbohydrate; 1g dietary fiber; 2g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("3"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" ounces (100g) pork rinds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (45ml) MCT oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("6 tablespoons (36g) "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch14#lev470",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nacho Cheese Powder")]), _vm._v(", divided")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poke a hole in the bag of pork rinds and break them up a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put the MCT oil in a 9 × 13-inch (23 × 33cm) pan and slosh it around. Dump in the rinds, and stir and turn them, coating them as evenly as possible. Put them in to bake, setting the timer for 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the timer beeps, sprinkle 3 tablespoons (18g) of the Nacho Cheese Powder over them, 1 tablespoon (6g) at a time, stirring each in well before adding the next. You’re trying to coat the rinds as evenly as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake the rinds for another 4 minutes. Then, repeat the sprinkling and stirring with the remaining 3 tablespoons (18g) of Nacho Cheese Powder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Store in an airtight container. Hide from the family.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev60"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31"
    }
  }, [_vm._v("SPICY PORK RINDS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("People think of pork rinds as being very fatty, but the truth is that most of the fat has been cooked out in the frying process—they have more protein than fat. Adding butter and MCT oil brings them closer to our desired macros. It improves the flavor and texture, too!")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("5 servings —")]), _vm._v(" Per serving: 177 calories; 14g fat (69.6% calories from fat); 12g protein; 1g carbohydrate; trace dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("2 tablespoons (28g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (15ml) MCT oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" ounces (100g) pork rinds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons hot sauce (I used Frank’s.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4). Put the butter and MCT oil in a 9 × 13-inch (23 × 33cm) roasting pan and slide it in to the oven, so the butter melts while you’re prepping the rest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poke a hole in your bag of pork rinds to let the air out. Now, squeeze or punch it to break the rinds up a bit; you want pieces in the 1-inch (2.5cm) range.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a small dish, stir together the paprika, garlic powder, salt, and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By now, your butter is melted! Pull the pan out of the oven. Add the hot sauce and stir it into the butter and oil and then add the pork rinds. Stir, turning everything over frequently, coating the pieces as evenly as you can.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now sprinkle in the spices, about one-fourth of the mixture at a time, stirring each addition in before adding the next. Again, you’re trying to coat all the pieces evenly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roast for 5 minutes and then stir again, turning everything over. Roast for another 3 to 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you don’t devour these while they’re warm—try making these on family movie night!—store them in an airtight container and consume within a few days.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev61"
    }
  }, [_vm._v("PARMESAN-DILL PORK RINDS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("This is another seasoning originally invented for popcorn that takes beautifully to pork rinds. It’s sure to please. Do make sure your dried dill has been recently purchased. That stuff you bought a year ago has no oomph left.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("6 servings —")]), _vm._v(" Per serving: 166 calories; 13g fat (69.2% calories from fat); 12g protein; 1g carbohydrate; trace dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("2 tablespoons (28g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (15ml) MCT oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" ounces (100g) pork rinds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon dried dill weed")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" cup grated (33g) Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven on to 350°F (180°C, or gas mark 4). Put the butter and MCT oil in a 9 × 13-inch (23 × 33cm) pan and put it in the oven while it heats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poke a hole in the bag of pork rinds to let the air out and then pound or squeeze them. You’re breaking them up into pieces a little bigger than popcorn (only flatter).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Measure the dill, garlic powder, and salt into a small cup and stir them together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the butter is melted, pull the pan out of the oven. Stir the butter and oil together and then add the pork rinds. Stir and turn them over until they’re evenly coated and all the butter mixture has been absorbed from the bottom of the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, sprinkle on the seasoning mixture in three additions, stirring after each to help distribute it evenly. Put the pan back in the oven and set the timer for 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the timer beeps, pull out the pan again. Sprinkle in the Parmesan in two or three additions, stirring to distribute it evenly. Bake for another 4 minutes. Let cool and store in an airtight container.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev62"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32"
    }
  }, [_vm._v("MOROCCAN-SPICED PORK RINDS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("I saw a recipe for Moroccan-spiced oyster crackers and thought, “Hmm. Pork rinds aren’t traditionally Moroccan, but neither are oyster crackers. I’ll give it a shot.” I’m glad I did; these are fantastic—one of the most impressive recipes in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("12 servings —")]), _vm._v(" Per serving: 146 calories; 11g fat (70.7% calories from fat); 10g protein; trace carbohydrate; trace dietary fiber.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("7 ounces (200g) pork rinds (This was 2 bags of Aldi’s house brand.)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" cup (80ml) MCT oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon ground ginger")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon ground allspice")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon smoked paprika")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon ground cloves")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poke a hole in each bag of pork rinds and then smash them a bit with your fists—you’re looking for pieces a little bigger than popcorn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pour the MCT oil into a huge roasting pan and then dump in the broken-up pork rinds. Stir until they’re all equally coated with the oil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Measure all the seasonings into a small bowl and stir until they’re evenly blended. Now, use a spoon to sprinkle the spices over the rinds a bit at a time—sprinkle a little, stir, sprinkle a little more, stir. You want all your pork rinds to get acquainted with the seasonings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake for 7 minutes and then stir. Bake for another 7 minutes, stir again, and give them another 3 or 4 minutes. Pull them out and let them cool a bit before transferring to a resealable plastic bag for storage.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev63"
    }
  }, [_vm._v("PARMESAN CRISPS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("These are becoming ubiquitous in grocery stores and even Costco. Still, they’re fresher this way. Do use Parmesan with no additives, even if it means you have to grate your own. The cellulose in most packaged grated Parmesan doesn’t work here.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("8 servings —")]), _vm._v(" Per serving: 23 calories; 2g fat (60.0% calories from fat); 2g protein; trace carbohydrate; 0g dietary fiber; trace net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (50g) grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 400°F (200°C, or gas mark 6). Line a baking sheet with parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put tablespoonfuls of Parmesan on the parchment, patting each little heap down a little and spacing them at least "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" inch (1.3cm) apart. Bake for 4 to 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These are also wonderful made in the microwave: coat a microwaveable plate or pie plate with cooking spray, arrange your little piles of Parmesan, and nuke on high for about 1 minute to 75 seconds, depending on the power of your microwave. It’s a different texture, but I actually prefer it to the baked; it has the same great flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('strong', [_vm._v("NOTE:")]), _vm._v(" If you need to grate your own Parmesan, the easiest way I know is to run it through the shredding blade of your food processor and then swap that out for the S-blade and pulse until it’s finely grated.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev64"
    }
  }, [_vm._v("CHEESE CRACKERS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("It’s shocking how much like a cracker this is. Really, try it.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("1 serving —")]), _vm._v(" Per serving: 424 calories; 35g fat (74.8% calories from fat); 25g protein; 2g carbohydrate; 0g dietary fiber; 2g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("1 slice of American cheese—the deluxe stuff")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Coat a microwaveable plate with nonstick cooking spray and lay the cheese on it. Microwave for 1 minute to 75 seconds. Let it cool a minute or so, peel it off the plate, and eat. If you’d like more cracker-size portions, cut the cheese into quarters before you nuke it.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev65"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33"
    }
  }, [_vm._v("COCOA-SPICE PECANS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Wow! Sweet, spicy, chocolaty, crunchy—what’s not to love? Your serving here is a scant "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (28g), though, so no devouring them all at once.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("3 cups (300g), 14 servings —")]), _vm._v(" Per serving: 163 calories; 16g fat (82.4% calories from fat); 2g protein; 5g carbohydrate; 2g dietary fiber; 3g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("1 egg white")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (28ml) vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon liquid stevia, English toffee")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 dash of water—just a few drops")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" cup (64g) erythritol")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (16g) cocoa powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 cups (300g) pecan halves")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 275°F (140°C, or gas mark 1). Line a jelly-roll pan or large, shallow roasting pan with parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a mixing bowl, whisk together the egg white, vanilla, liquid stevia, and water until frothy. In a small bowl, mix together the erythritol, cocoa, cinnamon, cayenne, and salt. Stir until evenly blended.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dump your pecans into the egg white mixture and stir until they’re all evenly coated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sprinkle about one-fourth of the cocoa-spice mixture over the pecans, and stir until it’s evenly distributed. Repeat another three times until all the mixture is worked in and all the pecans are evenly coated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spread the pecans on the prepared baking pan. Bake for 30 minutes, stirring every 10 minutes. Cool and store in a snap-top container, preferably somewhere out of sight.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev66"
    }
  }, [_vm._v("CINNAMON-GLAZED PECANS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Mildly sweet, a little salty, nicely crispy—these are irresistible. Take note: I made several batches of glazed pecans trying this idea out, and the friend who was helping (read: tasting) liked this mildly sweet version better than the sweeter Maple-Glazed Pecans (recipe follows).")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("3 cups (300g), 12 servings —")]), _vm._v(" Per serving: 181 calories; 18g fat (84.7% calories from fat); 2g protein; 5g carbohydrate; 2g dietary fiber; 3g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("1 egg white")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon water")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon liquid stevia, vanilla")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 cups (300g) pecan halves")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (48g) erythritol")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 250°F (120°C, or gas mark "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("). If you don’t have a nonstick 9 × 13-inch (23 × 33cm) pan, line one with nonstick foil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put the egg white in a deep, narrow bowl with the water and liquid stevia. Whisk until frothy. Add the pecan halves and use a spoon to stir until they’re all evenly coated with the egg white mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a small bowl, stir together the erythritol, cinnamon, and salt. Sprinkle this mixture, 1 tablespoon (12g) at a time, over the pecans, stirring each addition in well before adding the next.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spread the pecans in your prepared pan and put them in the oven. Bake for 1 hour, stirring every 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let cool before storing in an airtight container—for as long as you can keep them around!")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev67"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34"
    }
  }, [_vm._v("MAPLE-GLAZED PECANS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("These are more heavily glazed, and therefore sweeter—of course—than the Cinnamon-Glazed Pecans. Pass a dish of these around after a company dinner and call it dessert.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("3 cups (330g), 12 servings —")]), _vm._v(" Per serving: 182 calories; 18g fat (84.7% calories from fat); 2g protein; 5g carbohydrate; 2g dietary fiber; 3g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("1 egg white")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon water")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon maple extract (I use Boyajian, purchased through Amazon.com.)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon liquid stevia, English toffee")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 cups (300g) pecans")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (96g) erythritol")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 250°F (120°C, or gas mark "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a deep bowl, whisk the egg white with the water, maple extract, and liquid stevia until frothy. Add the pecans and stir until they’re evenly coated with the egg white mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stir together the erythritol, cinnamon, and salt. Sprinkle this mixture over the pecans, 1 tablespoon (12g) at a time, making sure each addition is evenly distributed before adding more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When all the erythritol is worked in, spread the pecans in a 9 × 13-inch (23 × 33cm) baking pan. Bake for 1 hour, stirring every 15 minutes. Let cool and break up any clumps before storing in an airtight container.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev68"
    }
  }, [_vm._v("ROSEMARY WALNUTS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Serve these at your next party and watch your reputation as a host or hostess soar. Or, hide them in the back of the cupboard and eat them all yourself; it’s up to you.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("12 servings —")]), _vm._v(" Per serving: 230 calories; 22g fat (81.2% calories from fat); 8g protein; 4g carbohydrate; 2g dietary fiber; 2g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("3 cups (300g) walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (3g) finely minced fresh rosemary")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (12g) erythritol")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spread the walnuts in a 9 × 13-inch (23 × 33cm) baking pan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Combine the olive oil and rosemary in a small bowl. Let it sit for 10 minutes for the flavor to infuse the oil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While that’s happening, stir together the erythritol, salt, and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pour the olive oil and rosemary over the walnuts and stir until they’re all evenly coated. Stir in the erythritol mixture in three additions, sprinkling each over the nuts and stirring it in well before adding more. Spread the nuts evenly in the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roast for 20 minutes, stirring two or three times. Let cool and store in an airtight container.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev69"
    }
  }, [_vm._v("SPICED WALNUTS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("These are slightly sweet, slightly spicy, entirely enchanting. Feel free to up the cayenne if you like or leave it out altogether, though there is only a hint of heat here.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("2 cups (240g), 8 servings —")]), _vm._v(" Per serving: 221 calories; 21g fat (80.5% calories from fat); 8g protein; 4g carbohydrate; 2g dietary fiber; 2g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("2 cups (200g) walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (28ml) MCT oil or (28g) coconut oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (36g) erythritol")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon ground coriander")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v(" teaspoon cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 250°F (120°C, or gas mark "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("). If you like, line a 9 × 13-inch (23 × 33cm) baking pan with nonstick foil. (My pans are nonstick.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put the walnuts and the oil in the pan—if you’re using coconut oil, melt it first by putting it in the pan and sliding it into the oven for a few minutes. Either way, stir until the walnuts are evenly coated with the oil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35"
    }
  }, [_vm._v("Measure everything else into a small dish and stir together. Now, sprinkle this mixture over the walnuts, just a little at a time, stirring well between each addition.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When all the spice mixture is in and your nuts are evenly coated, spread them evenly in the pan and put them in to roast. Set the timer for 12 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the timer beeps, pull your walnuts out, stirring and turning them over, and then spread them out again. Put them in for another 12 minutes. Do this twice more—the stirring and turning and spreading out—for a total of 48 minutes baking time. (This is not crucial, an extra minute or two is not a big deal.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let the nuts cool in the pan before transferring to an airtight container for storage.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev70"
    }
  }, [_vm._v("WICKED WINGS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("This is my most-pirated recipe—I’ve seen it all over the Internet. But then, I pirated it from my mom, and I think she got it from someone else long about 1965. So hey, pass on the love. I’ve increased the cheese mixture here because I’ve occasionally heard from people who ran out before they coated all their wings.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("50 servings —")]), _vm._v(" Per serving: 72 calories; 6g fat (72.1% calories from fat); 5g protein; trace carbohydrate; trace dietary fiber; 0g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("1"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cups (150g) grated Parmesan cheese—the cheap stuff in the green shaker")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (15g) dried parsley")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" tablespoons (5g) dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (7g) paprika")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 pounds (1.8kg) chicken wings, cut up")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (112g) butter, melted, or more if needed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4). Line a couple of roasting pans with foil. Do not skip the foil, or you’ll be faced with a two-fisted job getting the pans clean.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a large bowl, mix together the parmesan, parsley, oregano, paprika, salt (if using), and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, make an assembly line: Dip each wing piece in the melted butter, then the seasoned parmesan, and then lay it in the foil-lined pan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake for an hour. Serve to clamorous applause. Kick yourself for not making a double batch.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev71"
    }
  }, [_vm._v("SOY AND GARLIC WINGS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Sticky and tasty, these wings will liven up any gathering or just please the family on movie night. Don’t forget the napkins!")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("20 servings —")]), _vm._v(" Per serving: 56 calories; 4g fat (59.3% calories from fat); 5g protein; trace carbohydrate; trace dietary fiber; 0g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("20 chicken wings")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60ml) soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 cloves of garlic, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" tablespoons (23g) Virtue or Natural Mate sweetener")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon sriracha (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arrange your wings in a nonreactive baking pan—Pyrex is good, so is the new ceramic nonstick, which is what I used.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mix together the soy sauce, garlic, Virtue, and sriracha (if using). Pour over the wings and turn them over so that they’re all coated on both sides. Put ’em in the oven and set the timer for 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the timer beeps, use tongs to turn the wings over, dipping them in the sauce as you go. Bake for another 15 minutes and repeat until your wings are cooked through—mine were done in 45 minutes, but they were pretty small. If you’ve got big, meaty wings, they may take an extra 15 minutes.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev72"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36"
    }
  }, [_vm._v("BALSAMIC-GLAZED WINGS WITH CAESAR DRESSING")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("A little sweet, a little tangy, these wings are simple and good. The Caesar dressing is just the right foil.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("6 servings —")]), _vm._v(" Per serving: 236 calories; 22g fat (83.9% calories from fat); 6g protein; 3g carbohydrate; trace dietary fiber; 3g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("1"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" pounds (680g) chicken wings, cut up")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (28ml) extra-virgin olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon granulated garlic")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons salt or Vege-Sal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons Italian seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60ml) balsamic vinegar, divided")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("2")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" cup (160ml) "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#lev200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caesar Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put the wings in a mixing bowl. Pour in the olive oil and toss until they’re evenly coated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a small dish, mix together the granulated garlic, salt, and Italian seasoning. Sprinkle over the wings, a teaspoon at a time, tossing after each addition, until the wings are evenly seasoned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arrange the wings in a roasting pan. Roast for 30 minutes or until crunchy, basting once or twice with the fat in the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Baste the wings with the balsamic vinegar—the first basting will use up about half of it. Roast for another 10 minutes and then baste with the rest of the balsamic vinegar. Give them another 5 to 10 minutes. Serve with Caesar Dressing for dipping.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev73"
    }
  }, [_vm._v("BUFFALO WINGS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Restaurant Buffalo wings are commonly floured, or even breaded, before being fried in dubious oil. It is so unnecessary! Once you realize how easy these are, you’ll make them all the time. You can doctor this up if you want to—add a little cayenne if you like breathing fire or a crushed clove of garlic if you’re crazy about it. But the original hot-sauce-and-butter combo is deservedly adored. Don’t forget the blue cheese dressing and celery.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("28 servings —")]), _vm._v(" Per serving: 107 calories; 9g fat (75% calories from fat); 6g protein; trace carbohydrate; trace dietary fiber; 0g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("4 pounds (1.8kg) chicken wings, cut up (sometimes labeled “party wings”)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (112g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (120ml) hot sauce, such as Frank’s, Louisiana, or Tabasco")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Depending on the season, you can grill your wings or you can roast them at 375°F (190°C, or gas mark 5) for about 45 minutes; either way, get them good and crisp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, melt the butter and stir in the hot sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the wings are crisp and done, put them in a big mixing bowl. Pour on the sauce, and use tongs to toss until they’re all coated. That’s it. Set them out with a stack of napkins and plates for the bones.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev74"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37"
    }
  }, [_vm._v("HOT AND CREAMY WINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("The combination of chili-garlic sauce, no-sugar-added ketchup, and tahini makes this sauce hot, a little sweet, and creamy. You’ll need lots of napkins. Better yet, put a roll of paper towels on the table!")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("6 servings —")]), _vm._v(" Per serving: 191 calories; 14g fat (64.3% calories from fat); 14g protein; 4g carbohydrate; 1g dietary fiber; 3g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("3 pounds (1.4kg) chicken wings, cut up")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60g) chili-garlic sauce or sriracha")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60g) no-sugar-added ketchup")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (45g) tahini")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 clove of garlic, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon grated fresh ginger")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon dark sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arrange your wings on a couple of broiler racks or on racks in roasting pans. Roast them until crisp, a good 50 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the meanwhile, simply put everything else through your food processor or blender. Dump the mixture into a big mixing bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the wings are done, use tongs to transfer them to the bowl of sauce and toss them until coated. That’s it!")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev75"
    }
  }, [_vm._v("CHICKEN CHIPS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("This is a ringer, brought in from "), _c('em', [_vm._v("500 Low-Carb Recipes")]), _vm._v(". I invented it because of all my recipes that called for skinning the chicken before cooking. It’s hugely popular; every time I mention Chicken Chips online, people demand the recipe. Despite all the hand wringing over fat, skin is very nutritious stuff, full of gelatin. I buy extra chicken skin to make these with! If you have a local specialty butcher or poultry processor, ask them if they can save chicken skin for you. I buy 10 pounds (4.6kg) at a time and freeze it in baggies, each with just enough for a batch.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("Chicken skin—however much you’ve got")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Salt or other seasonings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While that’s happening, spread your chicken skin flat on a broiler rack. Include any lumps of fat you might have pulled off the chicken, too. Now, bake for 15 minutes or so, until it’s brown and crunchy. Sprinkle it with the seasoning of your choice or just eat them plain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have not been able to find nutrition stats for plain chicken skin, but here’s the important part: it’s zero carbs. You can save the fat that renders off the skin for cooking, too.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev76"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38"
    }
  }, [_vm._v("CRAB DIP")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Do not, for the love of all that is nutritious, use fake crab in this dip. The stuff almost always has added carbs, often quite a lot of added carbs. If you can’t afford crab, you could try tuna or just make a different recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("6 servings —")]), _vm._v(" Per serving: 226 calories; 21g fat (82.5% calories from fat); 8g protein; 2g carbohydrate; trace dietary fiber; 2g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("2 cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 scallions, trimmed and cut in a few shorter sections")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon Old Bay Seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("8 ounces (225g) cream cheese, softened")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60g) mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("6 ounces (170g) crab (Canned is fine.)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Salt to taste")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("With the S-blade in place in your food processor, add the garlic, scallions, and Old Bay. Pulse until the garlic and scallions are chopped medium fine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Add the cream cheese, mayonnaise, lemon juice, and Worcestershire and process, scraping down the sides once or twice, until it’s evenly blended. Dump in the crab and pulse just enough to mix it in—you want there to still be recognizable bits of crab in the mixture. Add a pinch or two of salt if you think it needs it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Serve this with celery, cucumbers, and/or green peppers for dipping or use it as an extremely luxurious omelet filling. Hey, you could even stuff mushrooms with it!")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev77"
    }
  }, [_vm._v("UPSCALE TUNA DIP")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("It’s the Cognac and pistachios that lift this above the ordinary. If you can’t or don’t want to use Cognac, there is brandy flavoring available, but not having used it, I can’t swear it will work here. But it’s worth trying, I’d think.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("5 servings —")]), _vm._v(" Per serving: 267 calories; 22g fat (75.7% calories from fat); 14g protein; 2g carbohydrate; 1g dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("5 ounces (140g) canned tuna in olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 ounces (115g) cream cheese, softened")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (42g) mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (28ml) Cognac")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 hard-boiled eggs, peeled and chunked")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (23g) shelled pistachios")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Put the tuna in your food processor, undrained. Add the cream cheese, mayonnaise, and Cognac. Process until smooth. Add the eggs, pistachios, and pepper and pulse to chop, but leave recognizable bits for texture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Serve with celery sticks, pepper strips, and cucumber rounds for dipping.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev78"
    }
  }, [_vm._v("PIZZA DIP")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Holy cow. Just… wow. This is amazing. But do be careful about your pizza sauce—most have added sugar. I like Pastorelli’s best, if you can get it. Read the labels!")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("6 servings —")]), _vm._v(" Per serving: 348 calories; 32g fat (80.5% calories from fat); 11g protein; 6g carbohydrate; trace dietary fiber; 6g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("12 ounces (340g) cream cheese, at room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (6g) Italian seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("2")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" cup (168g) pizza sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (115g) shredded mozzarella cheese")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (40g) shredded Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (28ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4). Coat an 8 × 8-inch (20 × 20cm) baking pan with cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the S-blade in place in your food processor, add the cream cheese, Italian seasoning, and garlic. Process until the garlic is fully pulverized, about 3 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39"
    }
  }, [_vm._v("Spread the cream cheese mixture evenly in the prepared pan. Spread the pizza sauce over that, then the mozzarella, and finally the Parmesan. Drizzle the olive oil over the whole thing, as evenly as possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake for 25 to 30 minutes. Serve hot with "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch03#lev97"
    }
  }, [_vm._v("Pepperoni Chips")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev79"
    }
  }, [_vm._v("BEAN DIP")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("I know many of you no longer eat soy. But I specifically had requests for dairy-free dips in this book, and bean dip is popular stuff. Do use black soybeans; they’re lower carb than the white ones. My local grocery stores carry them, but if yours don’t, try the health food store or, of course, online. Warmed through and topped with melted cheese, this would make a great side dish.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("1 cup (225g), 5 servings —")]), _vm._v(" Per serving: 167 calories; 14g fat (72.1% calories from fat); 7g protein; 6g carbohydrate; 4g dietary fiber; 2g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("13 ounces (365g) canned black soybeans")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 chipotle chile canned in adobo, plus 2 tablespoons (28ml) of the sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (28ml) lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60ml) melted bacon grease")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (3g) minced cilantro (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Lightly drain the soybeans and put them in your food processor. Add the garlic, chipotle and sauce, lime juice, bacon grease, and salt and process until everything is ground to a smooth paste, scraping down the sides of the processor as needed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Add the minced cilantro, if using, and pulse to mix it in. Done! Serve with veggies and pork rinds and tortilla chips for the carbivores.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev80"
    }
  }, [_vm._v("RICOTTA HERB DIP")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Our tester, Tere, suggests you try mixing this with shredded chicken to make chicken salad. Sounds good to me!")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("2"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cups (560g), 10 servings —")]), _vm._v(" Per serving: 164 calories; 13g fat (71.6% calories from fat); 9g protein; 3g carbohydrate; 1g dietary fiber; 2g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("15 ounces (425g) full-fat ricotta cheese")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (10g) fresh basil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (28ml) white balsamic vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (8g) fresh oregano")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 scallions, roots and any limp greens trimmed, and cut into a few chunks")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (28ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (68g) pine nuts")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60g) shredded Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Put everything but the shredded Parmesan and pine nuts in your food processor with the S-blade in place. Pulse until the herbs and scallions are finely chopped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stir the pine nuts in a dry skillet over medium-low heat until they’re golden. Add to the dip and pulse just one or two times to coarsely chop the pine nuts while mixing them in. Don’t overprocess!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Turn the dip out into a bowl and stir in the Parmesan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Serve with celery sticks, cucumber slices, and green pepper strips for dipping. If you have carbivores around, pita chips would be good with this.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('strong', [_vm._v("NOTE:")]), _vm._v(" A little of this spread on sliced deli turkey and rolled up would be good, too.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev81"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40"
    }
  }, [_vm._v("TUNA TAPANADE")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Serve this as a dip with vegetables or stuff into celery or cherry tomatoes for a killer hors d’oeuvre. It also makes an awesome omelet filling, especially with some feta thrown in.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("6 servings —")]), _vm._v(" Per serving: 149 calories; 12g fat (72.3% calories from fat); 9g protein; 2g carbohydrate; 1g dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("6 ounces (170g) canned tuna in olive oil, lightly drained")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (25g) pitted black olives")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (25g) pitted green olives")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 anchovy fillets")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (17g) capers, drained and rinsed")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (15ml) lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon dried basil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 pinch of pepper")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 clove of garlic, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (28ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (28g) mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (20g) diced red onion")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Just add everything to your food processor and pulse until the olives are chopped, but not puréed—you want a slightly rough texture.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev82"
    }
  }, [_vm._v("CHILE EGG ROLL-UPS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("This turns scrambled eggs into an appetizer—one that isn’t deviled eggs. It still has its share of heat, though. Feel free to reduce the pepper if you like or even cheat with sriracha.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("2 servings —")]), _vm._v(" Per serving: 224 calories; 17g fat (67.2% calories from fat); 11g protein; 7g carbohydrate; 1g dietary fiber; 6g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("3 scallions")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons minced hot red pepper, about 1 small red chile, such as a Thai bird pepper, or to taste")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" of a clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("5 tablespoons (75ml) soy sauce, divided")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (2g) minced cilantro (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 drop of liquid stevia, plain")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" tablespoons (23ml) MCT oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60ml) soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon sriracha (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Remove just the root and any limp greens from the scallions and cut them into a few chunks each. Put them in your food processor with the S-blade in place. Remove and discard the seeds and ribs from the pepper, mince to measure, and put that in, too. Immediately wash your hands thoroughly with soap and water! Then crush in the garlic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Run the food processor until the scallions and pepper are finely chopped. Now, add the eggs, 1 tablespoon (15ml) of the soy sauce, cilantro (if using), liquid stevia, salt, and pepper. Run just 20 seconds or so to mix everything up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put a large nonstick skillet—or a large skillet coated with nonstick cooking spray—over medium-high heat. Add the MCT oil and swirl it to coat the bottom of the pan. When the pan is good and hot, pour in the egg mixture. Again, swirl the pan and lift up the sides as they cook to let the raw egg flow under, as you would for an omelet. Turn the heat down to low, cover the pan, and give it 1 to 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the eggs are just done and the bottom is turning golden, slide the eggs out onto a plate—flat, like a pancake. Let the eggs cool for a few minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41"
    }
  }, [_vm._v("Meanwhile, make your dipping sauce by mixing together the remaining 4 tablespoons (60ml) of soy sauce, lime juice, and sriracha (if using).")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the eggs are cool enough to handle, roll them up jelly-roll fashion. Slice into "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("-inch (1.3cm) lengths—on the diagonal is prettier than straight across—and serve with the dipping sauce. Eat with your fingers!")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev83"
    }
  }, [_vm._v("MID-CENTURY MUSHROOMS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("This recipe started with an old cookbook I inherited from my mom—one of the spiral-bound kind, compiled and sold as a fundraiser. There was a dip recipe I found fascinating, but I didn’t want to “serve hot with crackers.” Then it hit me: mushrooms! Do buy average-sized mushrooms. I chose boxes with big ones, only to discover that on the really big mushrooms some of the filling “slumped” and wound up on the bottom of the pan, while all of the average-sized mushrooms looked like a picture in a magazine. They all tasted fantastic.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("20 servings —")]), _vm._v(" Per serving: 121 calories; 11g fat (79.4% calories from fat); 4g protein; 3g carbohydrate; 1g dietary fiber; 2g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (75g) pecans")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 ounces (115g) dried beef slices (aka chipped beef; you can buy it in 4-ounce [115g] jars)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" of a small onion, cut into chunks")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" of a green pepper, cut into chunks")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("12 ounces (340g) cream cheese, at room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30g) sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 pound (455g) mushrooms (average size; don’t buy the super-huge ones)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (45ml) melted butter")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First, put the pecans in your food processor with the S-blade in place. Pulse to chop them medium fine. Transfer them to a bowl and put the processor bowl and S-blade back on the processor base.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Open your jar of beef slices. They will come out in a roll. Do not bother to separate them. Just lay the roll of beef on your cutting board and slice across it at "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("-inch (1.3cm) intervals. Then, slice the other way, making "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("-inch (1.3cm) bits. Put ’em in your food processor. Add the onion and pepper. Crush in your garlic clove, too. Pulse until everything is finely chopped. Cut your cream cheese into 5 or 6 smaller chunks and put them in the food processor along with the sour cream. Run until everything is evenly blended.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now for the mushrooms: remove the stems and the little “skirt” over the gills, leaving a nice big surface for stuffing. Save the stems for an omelet or to top a hamburger!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put the melted butter in a 9 × 11-inch (23 × 28cm) roasting pan. Grab your processor bowl full of yummy stuffing and your bowl of chopped pecans. Stuff each mushroom with the chipped beef–cream cheese mixture, using a spoon to pack it in and round the top. As each is filled, turn it over and dip the top in the pecans. I had no trouble with filling dropping out, but if the first one does, pack the next one more firmly. As each mushroom is filled and topped with pecans, arrange in the pan, rolling the bottom slightly in the melted butter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake for 20 minutes and serve hot.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('strong', [_vm._v("NOTE:")]), _vm._v(" It’s embarrassing how long I can take to figure things out. I’ve been coming up with stuffed mushroom recipes for fifteen years now, and it was only with this recipe that it hit me: leftover stuffed mushrooms, chopped up, make a fantastic omelet filling.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev84"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42"
    }
  }, [_vm._v("CLAM-STUFFED MUSHROOMS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Recipe tester Virginia says, “This is a great idea for an impressive appetizer.” She also recommends that if you have any mushrooms left over, you slice them up and sauté them in the drippings the next day for an omelet filling. Who could argue with that?")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("About 30 servings —")]), _vm._v(" Per serving: 60 calories; 5g fat (73.0% calories from fat); 3g protein; 2g carbohydrate; trace dietary fiber; 2g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("2 pounds (910g) cremini mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (165g) butter, divided")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("6"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" ounces (185g) no-sugar-added canned clams (check the label), minced, juice reserved")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60g) "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#lev124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Rind Crumbs")])]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" cup (20g) minced parsley")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon salt or Vege-Sal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remove the stems from the mushrooms and reserve. Use the tip of a spoon to scrape the “skirt” from over the gills of the mushrooms, widening the opening. Discard the bits you scrape out. Finely chop the mushroom stems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put a large, heavy skillet over medium heat. Melt "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (112g) of the butter and sauté the garlic in it for a minute or two. Turn off the heat and roll the mushroom caps in the garlic butter, coating them, arranging them in a baking pan as you go.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Melt the remaining "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (55g) of butter in the skillet. Throw the chopped mushroom stems in the skillet and sauté for 4 to 5 minutes. Drain the juice from the clams into the skillet and stir the mushroom stems in the clam juice and garlic butter until softened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the liquid has evaporated from the skillet, stir in the clams, Pork Rind Crumbs, parsley, salt, and pepper, combining well. Stuff the mixture into the mushroom caps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake for 20 minutes. Then, turn on the broiler and run the mushrooms under it for just 3 to 4 minutes to brown. Serve hot.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev85"
    }
  }, [_vm._v("WALNUT-STUFFED MUSHROOMS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Our tester, Angele, says, “If these were at a party, I’d probably sit next to the tray. The filling tasted like it had meat in it, and it could easily pass itself off as a keto Thanksgiving stuffing.” She also says that she had about "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" cup (80g) leftover stuffing, and wished she’s had more mushrooms. I hesitated to rewrite the recipe because I didn’t want to make you buy another box of mushrooms and only use a few of them. But you can feel free to do so if you like. Just plan on another mushroom dish within a few days.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("About 12 servings —")]), _vm._v(" Per serving: 89 calories; 8g fat (76.6% calories from fat); 4g protein; 2g carbohydrate; 1g dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("8 ounces (225g) mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (55g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 large shallot, minced")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (60g) chopped walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (40g) "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#lev124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Rind Crumbs")])]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon thyme")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Salt to taste")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4). Coat an 8 × 8-inch (20 × 20cm) baking dish with nonstick cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remove the stems from the mushrooms and set aside. Use the tip of a spoon to scrape away the little “skirt” over the gills, making a larger opening for the stuffing. Chop the mushrooms stems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put a large, heavy skillet over medium-high heat and melt the butter. Throw in the shallot first and let it sauté for 1 to 2 minutes. Add the walnuts and chopped "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43"
    }
  }, [_vm._v("mushroom stems and sauté for another 3 to 4 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stir in the Pork Rind Crumbs, thyme, and pepper. Taste and see if you think it needs a little salt. Stuff the mixture into your mushroom caps and arrange them in the baking dish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake for 20 minutes. Serve hot.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev86"
    }
  }, [_vm._v("SEAFOOD-STUFFED MUSHROOMS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("This is called “Seafood-Stuffed Mushrooms” rather than “Crab-Stuffed Mushrooms” because, as our recipe tester Julie pointed out, you can substitute 1 pound (455g) of lobster meat for the crab—I mean, should you be feeling particularly flush or really want to impress somebody.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("24 servings —")]), _vm._v(" Per serving: 82 calories; 7g fat (75.9% calories from fat); 4g protein; 1g carbohydrate; trace dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (112g) butter, divided")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (8g) minced celery")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (10g) minced onion")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (9g) minced jalapeño")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (4g) minced parsley")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 dashes of pepper")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (120ml) seafood stock (I used Kitchen Basics.)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("6 drops of liquid stevia, plain")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60g) "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#lev124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Rind Crumbs")])]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (142g) lump crabmeat")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 egg, beaten")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 pound (455g) mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("8 ounces (225g) shredded Monterey Jack cheese")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Paprika, for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 375°F (190°C, or gas mark 5).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a large saucepan over medium-low heat, melt 4 tablespoons (55g) of the butter. Add the celery, onion, jalapeño, and parsley. (Don’t forget to wash your hands well after handling that jalapeño!) Sauté for 2 to 3 minutes. Stir in the salt and pepper. Add the seafood stock and liquid stevia and bring to a simmer. Decrease the heat to low and let it simmer gently for 5 minutes. Stir in the Pork Rind Crumbs and remove from the heat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mix the crabmeat with the egg, flaking up the crab as you stir. Then, stir the crab-egg mixture into the pork rind mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remove the stems from the mushrooms, saving them to sauté to top a steak or fill an omelet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Melt the remaining 4 tablespoons (55g) of butter and brush the mushroom caps with it. Stuff each with 2 to 3 teaspoons (10 to 15g) of the crab mixture. Top each with a big pinch of shredded cheese and a light dusting of paprika.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake for 15 minutes or until the cheese is touched with gold. Serve hot.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('strong', [_vm._v("NOTE:")]), _vm._v(" Do not use fake seafood! It almost always has added carbs, often a lot of added carbs.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev87"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44"
    }
  }, [_vm._v("SPINACH-STUFFED MUSHROOMS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("This is a classic crowd-pleaser. I’ve never brought a single one home from a party.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("40 servings —")]), _vm._v(" Per serving: 24 calories; 2g fat (62.7% calories from fat); 1g protein; 1g carbohydrate; trace dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("1"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" pounds (680g) mushrooms, wiped clean")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (28g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" of a large or 1 small onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 cloves of garlic, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("10 ounces (280g) frozen chopped spinach, thawed")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 ounces (115g) cream cheese")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon salt or Vege-Sal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoons Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (25g) grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wipe the mushrooms clean and remove the stems. Set the caps aside and chop the stems fairly fine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a large, heavy skillet over medium-low heat, melt the butter. Add the chopped stems and the onion. Sauté until the mushroom bits are changing color and the onion is soft and translucent. Add the garlic, stir it up, and sauté for another couple of minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While that’s happening, dump your thawed spinach into a strainer and press all the water out of it that you can. Now, stir it into the mushroom-onion mixture. Next, stir in the cream cheese. When it’s melted, add the pepper, salt, and Worcestershire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stuff the spinach mixture into the mushroom caps. Arrange the stuffed caps in a baking pan as you go. When they’re all stuffed, sprinkle the Parmesan cheese over them, doing your best to distribute it evenly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake for 20 minutes. Serve warm.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev88"
    }
  }, [_vm._v("TWO-CHEESE TUNA-STUFFED MUSHROOMS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("These may be my favorite stuffed mushrooms ever. But then, I have always loved canned tuna. It’s such an odd thing to be passionate about, isn’t it? Do pop for the good stuff in olive oil. When you’re eating a high-fat diet, the quality of the fat matters.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("30 servings —")]), _vm._v(" Per serving: 63 calories; 5g fat (64.7% calories from fat); 5g protein; 1g carbohydrate; trace dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("1 pound (455g) mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("12 ounces (340g) canned tuna in olive oil, lightly drained")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (120g) shredded smoked Gouda cheese")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 tablespoons (25g) grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("6 tablespoons (84g) mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 scallions, finely minced")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Paprika, for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4). Coat an 11 × 13-inch (28 × 33cm) roasting pan with cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remove the stems from your mushrooms, reserving them to sauté for steak or omelets. Use the tip of a spoon to scrape the “skirt” from over the gills, leaving more space for filling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a bowl, combine the tuna, Gouda, Parmesan, mayonnaise, and scallion, mixing well. Stuff the mixture into the mushrooms, arranging them in the pan as you go. Sprinkle lightly with paprika.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake for 25 to 30 minutes. Serve hot.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev89"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45"
    }
  }, [_vm._v("BLUE CHEESE–WALNUT CELERY STICKS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("I’d go with a mild blue cheese for this, like Gorgonzola or Dana Blue, rather than something really strong, like Stilton. My tester Rebecca offers the useful advice that if you buy your walnuts chopped, you can skip the food processor and mix the filling in a bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("6 servings —")]), _vm._v(" Per serving: 179 calories; 16g fat (76.4% calories from fat); 6g protein; 5g carbohydrate; 2g dietary fiber; 3g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (50g) walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 ounces (115g) cream cheese, softened")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60g) sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (30g) blue cheese, divided")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("12 celery ribs (Use the tender center ribs.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven on to 350°F (180°C, or gas mark 4). Spread your walnuts in a shallow baking dish. Put in the oven and set the timer for 7 minutes. You just want them to smell toasty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the S-blade in place in your food processor, add the cream cheese and sour cream and process until they’re well combined. Add half of the blue cheese and pulse a couple of times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By now, the walnuts are smelling toasty. Put them in the food processor and pulse until they’re chopped to a medium consistency. Add the rest of the blue cheese and pulse just once or twice—you want to maintain chunks of blue cheese and walnut.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stuff the mixture into the celery—cutting the ribs into whatever lengths you find appealing—and they’re done.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev90"
    }
  }, [_vm._v("EGGS IN TUNISIA")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Harissa is a Tunisian spice mix using hot peppers and herbs. Locally, I can buy it both in powder and paste form—I used powder in this recipe. Mine was from an organic spice company called Frontier and not terribly hot, hence the cayenne. You’ll want to taste your yolk mixture after you’ve added the harissa and salt before you decide whether you want cayenne.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("12 servings —")]), _vm._v(" Per serving: 90 calories; 8g fat (81.5% calories from fat); 4g protein; 1g carbohydrate; trace dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("6 hard-boiled eggs")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("5 or 6 saffron threads")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon hot water")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" cup (75g) mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 ounces (55g) chèvre cheese")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (15g) harissa")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (1g) minced cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Halve your eggs, turning the yolks out into a mixing bowl and arranging the whites on a platter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put the saffron threads in a small bowl or cup, stir them with the hot water, and leave them to sit for a few minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Use a fork to mash your yolks as finely as you can. Add the steeped saffron, mayonnaise, chèvre, harissa, and salt and stir with a spoon, using the back of it to smash any lumps of yolk against the side of the bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now taste: Is the degree of heat to your liking? If not, add the cayenne. Heck, add more cayenne if you want to, who am I to judge? Stir in the cilantro and then stuff the yolk mixture into the whites.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev91"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46"
    }
  }, [_vm._v("GODDESS EGGS!")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Care to hatch out a goddess or two? No, no, they’re eggs based on Green Goddess Dressing. And you make a full dozen because otherwise you’d be left with half an avocado. Our tester Rebecca says that these are a little trouble to make because you need to have both a ripe avocado and fresh tarragon in the house at the same time. She adds, however, that her furnace guy was there when she had these in the house, and it turns out he’s a serious foodie. She said he kept going on and on about these—“Said it was right up there with Oysters Rockefeller for the pizzazz coming out of nowhere.” So, it’s worth acquiring an avocado and some tarragon, especially if you’re having a party.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("24 servings —")]), _vm._v(" Per serving: 67 calories; 6g fat (73.3% calories from fat); 3g protein; 1g carbohydrate; trace dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("12 hard-boiled eggs")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (42g) mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (15g) sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (4g) minced parsley, plus more for garnish (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (4g) minced fresh tarragon, plus more for garnish (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 scallion, including the crisp part of the green, cut into 1-inch (2.5cm) lengths")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (15ml) lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 anchovy fillet")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 clove of garlic, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 avocado, good and ripe")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Salt and pepper to taste")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Peel your eggs and halve them, turning the yolks out into a mixing bowl and arranging the whites on a platter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the S-blade in place in your food processor, add the mayonnaise, sour cream, parsley, tarragon, scallion, lemon juice, Dijon mustard, anchovy, and garlic. Process until the anchovy vanishes and the herbs are finely chopped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Halve the avocado, remove the pit, and spoon half of the flesh into the food processor. Process again until it’s blended in and the mixture is creamy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Turning to those yolks, grab a fork and mash them quite well. Now, add the mixture from the food processor and continue mixing and mashing until it’s all creamy and well blended. Spoon in the rest of the avocado in smallish spoonfuls. Mash and stir until it’s blended in, but you still have some nice hunks of avocado.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stuff your egg whites with this fantastic stuff! You’ll really have to overstuff ’em because there will be plenty of yolk mixture. Pile it high.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Garnish with more herbs if you like and serve immediately.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev92"
    }
  }, [_vm._v("SRIRACHA MUSTARD EGGS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("I love mustard and I love sriracha, so when I saw sriracha mustard at the grocery store, I had to have it. Once I had it, these eggs were simply a matter of time.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("12 servings —")]), _vm._v(" Per serving: 66 calories; 6g fat (77.8% calories from fat); 3g protein; trace carbohydrate; trace dietary fiber; 0g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("6 hard-boiled eggs")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (42g) mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30g) sriracha mustard")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon fish sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons minced cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Halve the eggs, turning the yolks out into a mixing bowl and arranging the whites on a platter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Using a fork, mash the yolks as fine as you can. Add the mayonnaise, sriracha mustard, and fish sauce and stir with a spoon, using the back of it to smash any chunks of yolk against the side of the bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this point, you can stir in the cilantro before stuffing the yolks into the whites—I did. Or, you can stuff the yolk mixture into the whites and then sprinkle the cilantro on top. It’s your choice.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev93"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47"
    }
  }, [_vm._v("GREEN OLIVE EGGS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("If you’re a stuffed egg fan, browse the condiments selection at your grocery and health food stores. You’ll find all sorts of ideas! I found a lovely green olive spread—olives, olive oil, coriander, lemon juice, basil, and garlic—at my grocery store and used it to make these.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("12 servings —")]), _vm._v(" Per serving: 64 calories; 6g fat (77.9% calories from fat); 3g protein; 1g carbohydrate; trace dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("6 hard-boiled eggs")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (42g) mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (24g) green olive spread")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon red wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (4g) minced parsley")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon salt or Vege-Sal")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Halve your eggs, turning the yolks out into a mixing bowl and arranging the whites on a platter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Use a fork to mash your yolks fine. Then, add the mayonnaise and stir with a spoon, using the back of it to smash lumps of yolk against the side of the bowl. When your yolks are getting smooth, stir in the green olive spread, red wine vinegar, parsley, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stuff the yolk mixture into the whites.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev94"
    }
  }, [_vm._v("HAM AND WALNUT STUFFED EGGS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("I know, I know—no one ever gets tired of classic deviled eggs. But sometimes you want to take something a little different to the potluck, or you want a variety to choose from at your party. Or, as seems to happen to me at least once a year, you have an excess of both eggs and ham at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("12 servings —")]), _vm._v(" Per serving: 98 calories; 9g fat (76.8% calories from fat); 5g protein; 1g carbohydrate; trace dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (25g) walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("6 hard-boiled eggs")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 ounces (55g) cooked ham, in a few small chunks")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 scallion, including the crisp green part, cut into a few pieces")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60g) mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" tablespoons (23g) Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons red wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon hot sauce (Tabasco, Frank’s, or Louisiana), or to taste")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Salt and pepper to taste")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (8g) finely minced parsley (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4). Spread your walnuts on a shallow baking sheet and stick ’em in. Set a timer for 7 minutes—they’re likely to be toasted before the oven is all the way up to temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Peel your eggs. Halve them, turning the yolks out into a mixing bowl and arranging the whites on a platter. Do a preliminary mashing of the yolks with a fork.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When your walnuts smell toasty, put them in your food processor with the ham and scallion. Pulse until it’s all ground medium-fine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Add the mayonnaise, Dijon mustard, red wine vinegar, and hot sauce to the yolks and mash and stir until they’re smooth and creamy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Transfer the ham-and-walnut mixture from the food processor to the mixing bowl and work it into the yolks until it’s all evenly blended. Season with salt and pepper to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stuff the yolk mixture into the whites. Because you’ve added ham and walnuts, you’ll have enough to stuff them generously, so pile the filling high. If you want to make ’em look spiffy, sprinkle a little parsley on each one, but it’s not essential. They’ll vanish regardless.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev95"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48"
    }
  }, [_vm._v("HAM ROLLS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Quick and easy to make, these are a terrific snack. The counts on this assume your ham runs 1 ounce (28g) per slice.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("6 servings —")]), _vm._v(" Per serving: 161 calories; 16g fat (81.4% calories from fat); 6g protein; 2g carbohydrate; trace dietary fiber; 2g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("6 slices (1 ounce, or 28g each) of deli ham")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("6 tablespoons (84g) mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 tablespoons (60g) brown mustard")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("6 tablespoons (43g) shredded Colby Jack cheese")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 dill pickle spears (or sugar-free bread-and-butter pickles)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Lay a slice of ham on a cutting board or plate. Spread with mayonnaise, then mustard. Sprinkle the cheese evenly over that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slice each of your pickle spears lengthwise into 3 pieces. Lay one at the end of your now-bedecked ham slice and roll the ham and cheese up around the pickle. Repeat with the rest of your ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Store in a snap-top container, ready to pull out when hunger strikes.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('strong', [_vm._v("NOTE:")]), _vm._v(" If you’d like to make these fancy enough for a party, simply slice each roll into 1-inch (2.5cm) lengths and lay the little pink-white-yellow-and-green pin-wheels on a lettuce-lined plate.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev96"
    }
  }, [_vm._v("SALAMI CHIPS WITH PESTO CREAM")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("I knew that pepperoni makes great chips, so why not salami? And why not their very own topping? It’s quick, easy, and unusual.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("3 servings —")]), _vm._v(" Per serving: 173 calories; 15g fat (77.6% calories from fat); 8g protein; 2g carbohydrate; trace dietary fiber; 2g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("6 slices of salami")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60g) sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons pesto")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Salt to taste")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4). Line a cookie sheet with parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lay the slices of salami on the parchment. Bake for 10 to 12 minutes. It will not be quite crisp when it comes out—it will become crisper as it cools.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the meanwhile, stir the sour cream and pesto together, adding salt to taste. Spread each salami chip with the pesto cream and serve.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev97"
    }
  }, [_vm._v("PEPPERONI CHIPS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("I usually make pepperoni chips in the microwave—just lay 14 slices (1 ounce, or 28g) on a microwaveable plate and nuke for 60 to 75 seconds. But, you can do a whole lot more in your regular oven. So, if you’re making them for the family or a party, do this.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("1 serving —")]), _vm._v(" Per serving: 845 calories; 75g fat (80.7% calories from fat); 36g protein; 5g carbohydrate; 0g dietary fiber; 5g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("6 ounces (170g) pepperoni slices")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 375°F (190°C, or gas mark 5). Line a baking sheet with parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lay the pepperoni slices on the parchment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake for 10 minutes. Blot with paper toweling and then give them another 2 to 4 minutes until very crisp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These are great served with whipped cream cheese, but for something really spectacular, use them to scoop the "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch03#lev78"
    }
  }, [_vm._v("Pizza Dip")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev98"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49"
    }
  }, [_vm._v("COCKTAIL MEATBALLS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("The unusual preparation method makes for a fantastic texture to these meatballs, while the sauce lends a sweet-and-sour snap. A slow cooker full of these will please a party crowd. This is a huge batch! If you’d like to halve it, use "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60g) pork rind crumbs.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("80 servings —")]), _vm._v(" Per serving: 49 calories; 4g fat (72.9% calories from fat); 3g protein; trace carbohydrate; trace dietary fiber; 0g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("MEATBALLS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" ounces (100g) pork rinds (There are bags just this size.)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons salt or Vege-Sal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon allspice")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 cloves of garlic, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (120ml) cream")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 pounds (910g) ground beef, divided")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("SAUCE")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (240g) no-sugar-added ketchup")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 tablespoons (45ml) balsamic vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 teaspoons (20ml) Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" of a shallot, minced")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 clove of garlic, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon liquid stevia, English toffee")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (48g) erythritol")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon molasses")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4). Coat 2 broiler racks with nonstick cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To make the meatballs, with the S-blade in place in your food processor, dump the pork rinds in and process until they’re crumbs. Add the salt, baking powder, pepper, and allspice and pulse to mix them in. With the motor running, add the garlic, then the eggs, and then the cream. You will quickly have a gloppy mess. Do not panic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Set aside half of the ground beef. With the remaining beef, take the lid off the processor and add about one-third of it. Put the lid back on and process to work it in. Repeat twice, with the remaining two-thirds of beef. The mixture in the food processor will now be quite thick and sticky. Spoon/scrape it into a mixing bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wash your hands and then run them under cold water—this minimizes the meat sticking to your hands. Add the ground beef you set aside, and use your hands to smoosh it quite thoroughly into the processed mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the cold water, your hands will be a gloppy mess. Wash them. Now grab your prepared broiler racks and a bowl of cold water—this is for dunking your hands in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Form the meat mixture into 1-inch (2.5cm) balls, dunking your hands in the water after every 2 or 3 meatballs. Arrange them on the broiler racks as you go.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake for 20 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To make the sauce, combine all the sauce ingredients in a nonreactive saucepan (stainless steel or ceramic nonstick are good). Bring to a simmer and cook for 10 minutes. Pour over the meatballs to serve. I put ’em in my slow cooker to keep them warm, but a chafing dish will do fine, too.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev99"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50"
    }
  }, [_vm._v("ALBONDIGAS DE GUATELOTE, QUESO, TOCINO, Y CHIPOTLE")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("That’s “Turkey, Cheese, Bacon, and Chipotle Meatballs,” for those of you who didn’t take Spanish. And boy, are they tasty. You can serve these as is—they stand on their own—or dip them in queso or "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch14#lev486",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crema Caliente")]), _vm._v(" for extra fat.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("Makes about 40 meatballs —")]), _vm._v(" Per serving: 49 calories; 3g fat (52.1% calories from fat); 5g protein; trace carbohydrate; trace dietary fiber; 0g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("2 pounds (910g) ground turkey")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" of a medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" ounces (42g) pork rinds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (28g) bacon bits")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 chipotle chiles canned in adobo plus 1 tablespoon (15ml) sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("8 ounces (225g) finely shredded Mexican 4-cheese blend")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon ground dried rosemary")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Preheat the oven to 350°F (180°C, or gas mark 4). Coat your broiler rack with nonstick cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put your ground turkey in a big mixing bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cut your onion into a few chunks and throw it into the food processor along with the garlic. Pulse until they’re finely chopped. Now, add the pork rinds, bacon bits, and chipotles to the processor and run until the pork rinds have been ground into crumbs. Add this mixture to the turkey, using a rubber scraper to get all of it out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Add the adobo sauce, cheese, eggs, rosemary, salt, and pepper. Use clean hands to smoosh it all together very thoroughly, turning everything over several times to make sure there are no pockets of cheese that haven’t been worked in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Form into balls about 1"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" inches (3.8cm) in diameter and arrange on the broiler rack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bake for 25 minutes or until cooked through.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev100"
    }
  }, [_vm._v("SMOKED SALMON MOUSSE")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("This can be served as a dip, as suggested—that’s obviously the easiest route. But if you’re feeling fancy, spoon the mousse into a pastry bag with a star tip and pipe it prettily onto the cucumber rounds and into the celery sticks. Me, I’d probably only do that for a pretty special occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("6 servings —")]), _vm._v(" Per serving: 147 calories; 12g fat (72.9% calories from fat); 9g protein; 1g carbohydrate; trace dietary fiber; 1g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("4 ounces (115g) cream cheese, softened")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 scallions")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (4g) minced fresh dill")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (4g) minced fresh parsley")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon prepared horseradish")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("8 ounces (225g) smoked salmon, any bones removed")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60ml) heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon hot sauce (Tabasco, Frank’s, or Louisiana)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Salt and pepper to taste")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("This could not be easier! Simply put everything but the salt and pepper in your food processor and process until it’s smooth and creamy. Add salt and pepper to taste and process again for just a moment or two to mix it in. Scoop it into a pretty bowl and chill for a few hours to let the flavors blend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Serve with celery and cucumbers for dipping.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev101"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_51"
    }
  }, [_vm._v("SMOKED SALMON ROLLS")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("I know you’re not going to buy caviar every day, but this was just too impressive to pass up. If you’re planning a get-together with people you really need to impress, look no further. Our tester, Rebecca, says that black caviar will serve as well and is less expensive than red caviar. She also says that leftovers, should you have any, are great chopped up and used as a spread or an omelet filling.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("6 servings —")]), _vm._v(" Per serving: 228 calories; 18g fat (69.8% calories from fat); 15g protein; 3g carbohydrate; trace dietary fiber; 3g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("8 ounces (225g) whipped cream cheese")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30g) sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 scallions, finely minced")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (4g) minced parsley")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 ounces (55g) red caviar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("12 ounces (340g) smoked salmon lox, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("In a mixing bowl, work the cream cheese, sour cream, minced scallion, and parsley together until well blended. Gently fold in the caviar, trying not to break the eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spread the mixture on slices of salmon and then roll each up and cut into 1"), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("-inch (3.8cm) lengths. Arrange the pretty pinwheels on a lettuce-lined plate and bear them forth, feeling smug.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r",
    attrs: {
      "id": "lev102"
    }
  }, [_vm._v("HERBERT D. FOCKEN’S SWEETENED JALAPEÑO BITES, UPDATED")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Herbert D. Focken sent in this idea for "), _c('em', [_vm._v("500 More Low-Carb Recipes")]), _vm._v(", and I’ve been in love with it ever since. But I thought it time to create a version with today’s more popular sweeteners.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("YIELD:")]), _vm._v(" "), _c('strong', [_vm._v("Varies —")]), _vm._v(" Per serving: 92 calories; 3g fat (26.8% calories from fat); 3g protein; 16g carbohydrate; 9g dietary fiber; 7g net carbohydrate.")]), _vm._v(" "), _c('p', {
    staticClass: "itemt"
  }, [_vm._v("12 ounces (340g) jarred jalapeño peppers, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon liquid stevia, plain, or liquid monk fruit, or liquid sucralose to equal "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (150g) sugar in sweetness")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Pork rinds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Whipped cream cheese")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("This could not be simpler! Open your jar of jalapeños. Add the sweetener. Put the lid back on tightly and shake it up. Stick it in the fridge for a few days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When snack time rolls around, grab your sweetened jalapeños, a bag of pork rinds, and a tub of whipped cream cheese. Spread cream cheese on a pork rind. Put a few slices of jalapeño on it. Stuff it in your face. Repeat.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('strong', [_vm._v("NOTE:")]), _vm._v(" It was impossible to analyze per slice or per serving. The entire jar of jalapeños will have 16 grams of carbohydrate,9 of those fiber, for a net carbohydrate count of 7 grams for the whole darned jar. Pork rinds are carb free, though a little high in protein and low in fat for our purposes. The whipped cream cheese has our needed fat. So make these. Eat these. They will make you happy.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ecf8ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 69
// module chunks = 0